module.exports = __webpack_public_path__ + "static/homepage-bee55d5c5bf46c9c050f04a4234d6ada.mp4";